class CuriositiesSlider {
    constructor(module) {
        this.module = module
        this.slider = this.module.querySelector('.section-slider')
        this.sliderWrapper = this.module.querySelector('.swiper-wrapper')
        this.items = this.module.querySelectorAll('.section-slider-item')

        this.players = []
        
        this.init()
    }

    init() {
        if (!this.slider) return

        const initSwiper = () => {
            if (typeof Swiper !== 'undefined') {
                this.swiper = new Swiper(this.slider, {
                    slidesPerView: 'auto',
                    navigation: {
                        prevEl: this.module.querySelector('.js-swiper-prev'),
                        nextEl: this.module.querySelector('.js-swiper-next'),
                    },
                    on: {
                        slideChange: () => {
                            this.items.forEach((item, i) => {
                                item.classList.remove('is-playing')
                                if (this.players[i] && typeof this.players[i].pauseVideo === 'function') {
                                    this.players[i].pauseVideo()
                                }
                            })
                        }
                    }
                })
                
                const firstSlide = this.slider.querySelector('.swiper-slide')
                if (firstSlide) {
                    const slideHeight = firstSlide.offsetHeight
                    this.sliderWrapper.style.minHeight = slideHeight + 'px'
                }
            } else {
                setTimeout(initSwiper, 100)
            }
        }

        initSwiper()

        this.initPlayer()
    }

    initPlayer() {
        this.items.forEach((item, i) => {
            this.button = item.querySelector('.curiosities-slider-button')

            if (this.button) {
                const videoElement = item.querySelector('.curiosities-slider-video-element')
                const youtubeId = videoElement.dataset.youtubeId

                this.button.addEventListener('click', () => {
                    if (!this.players[i]) {
                        this.loadVideo(videoElement, youtubeId, i)
                    }

                    item.classList.add('is-playing')
                })
            }
        })
    }

    loadVideo(videoElement, youtubeId, i) {
        // Initialize the YT Player
        this.players[i] = new YT.Player(videoElement, {
            height: '360',
            width: '640',
            videoId: youtubeId,
            events: {
                'onReady': (event) => event.target.playVideo()
            }
        })
    }
}

const sections = document.querySelectorAll('.curiosities-slider')
sections.forEach((section) => {
    new CuriositiesSlider(section)
})

// Inject YouTube API Script
if (!window.YT && !document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
    const tag = document.createElement('script')
    tag.src = "https://www.youtube.com/iframe_api"
    const firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
}
